"use client"

import { useEffect, useRef, useState } from 'react'

import SvgIcon from '@components/shared/svg-icons/SvgIcon'
import useT from '@hooks/useTranslation'
import { clearLastSearch, readLastSearch } from '@components/search/lastSearch'

import styles from './QuickSearches.module.css'

const HOST = process.env.NEXT_PUBLIC_HOST

// „Często szukane”. Ostatnie wyszukiwanie (localStorage) zastępuje pierwszy rząd
// w tym samym miejscu i tej samej wysokości, więc odczyt po hydratacji nie przesuwa układu.
// rows: dwa rzędy skrótów { t, href } (adresy liczone na serwerze, quickSearchLinks).
export default function QuickSearches ({ rows }) {
    const [row1 = [], row2 = []] = rows || []
    const t = {
        title: useT('Często szukane'),
        more: useT('Często szukane, ciąg dalszy'),
        last: useT('Ostatnio'),
        back: useT('Wróć do ostatniego wyszukiwania'),
        clear: useT('Usuń ostatnie wyszukiwanie'),
    }

    const [last, setLast] = useState(null)
    const row1Ref = useRef(null)
    const focusRow1 = useRef(false)

    useEffect(() => setLast(readLastSearch()), [])

    // Po usunięciu fokus na pierwszy skrót (przycisk znika razem z wierszem).
    useEffect(() => {
        if (!last && focusRow1.current) {
            focusRow1.current = false
            row1Ref.current?.querySelector('a')?.focus()
        }
    }, [last])

    const onClear = () => {
        clearLastSearch()
        focusRow1.current = true
        setLast(null)
    }

    return (
        <div className={styles.quick}>
            <p className={styles.title} id="quick-title">{t.title}</p>
            <div className={styles.rows}>
                <nav aria-labelledby="quick-title" className={styles.row} hidden={Boolean(last)} ref={row1Ref}>
                    { row1.map(l => <a className={styles.chip} href={l.href} key={l.href}>{l.t}</a>) }
                </nav>
                <div className={styles.row} hidden={!last}>
                    { last && (
                        <div className={styles.resume}>
                            <SvgIcon name="history" />
                            <a aria-label={`${t.back}: ${last.label}`} href={HOST + last.url}>
                                <span>{t.last}: <strong>{last.label}</strong></span>
                            </a>
                            <button aria-label={t.clear} className={styles.clear} onClick={onClear} type="button">
                                <SvgIcon name="close" size="sm" />
                            </button>
                        </div>
                    ) }
                </div>
                <nav aria-label={t.more} className={styles.row}>
                    { row2.map(l => <a className={styles.chip} href={l.href} key={l.href}>{l.t}</a>) }
                </nav>
            </div>
        </div>
    )
}
